import React, { useState } from "react";
import "./Tabs.scss";

const Tabs = ({ onTabChange }) => {
    const [activeTab, setActiveTab] = useState("Semana");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        onTabChange(tab);
    };

    return (
        <div className="tabs-container">
            <div className="tabs">
                <button
                    className={`tab ${activeTab === "Semana" ? "active" : ""}`}
                    onClick={() => handleTabClick("Semana")}
                >
                    Semana
                </button>
                <button
                    className={`tab ${activeTab === "Mes" ? "active" : ""}`}
                    onClick={() => handleTabClick("Mes")}
                >
                    Mes
                </button>
                <button
                    className={`tab ${activeTab === "Año" ? "active" : ""}`}
                    onClick={() => handleTabClick("Año")}
                >
                    Año
                </button>
            </div>
        </div>
    );
};

export default Tabs;
